import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './screens.js/home';
import Learn from './screens.js/learn';
import Test from './screens.js/test';

import TestInverse from './screens.js/test-inverse';
import SignUp from './screens.js/signup';
import Login from './screens.js/login';
import { useGlobalContext } from './context';
import MyNavbar from './components/Navbar';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { userInfo } = useGlobalContext();

  return (
    <BrowserRouter>
      <div className="container ">
        <ToastContainer position="bottom-center" limit={1} />
        {userInfo && (
          <h5>
            User:<span className="header">{userInfo.name} </span> lesson:{' '}
            <span className="header">{userInfo.lessons} </span>
          </h5>
        )}{' '}
        <MyNavbar />
        <Routes>
          <Route path="/" element={<Home />} />{' '}
          <Route path="/learn" element={<Learn />} />{' '}
          <Route path="/test" element={<Test />} />{' '}
          <Route path="/eng-jap" element={<TestInverse />} />{' '}
          <Route path="/signup" element={<SignUp />} />{' '}
          <Route path="/login" element={<Login />} />{' '}
          <Route path="*" element={<div> Nobody here </div>} />
        </Routes>{' '}
      </div>{' '}
    </BrowserRouter>
  );
}

export default App;
